// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import ElementUi from '@/utils/element-ui'
import Utils from '@/utils'

Vue.use(VueLazyload)
Vue.use(ElementUi)
Vue.use(Utils)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js